import { CommonModule } from '@angular/common';
import { HistoricalBottomSheetComponent } from './historical-bottom-sheet.component';
import { IconAndMessageComponent } from './icon-and-message/icon-and-message.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MovementHistoryTableComponent } from './movement-history-table/movement-history-table.component';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedDirectivesModule } from 'src/app/shared/shared-directives.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [HistoricalBottomSheetComponent, IconAndMessageComponent, MovementHistoryTableComponent],
  imports: [CommonModule, MatProgressSpinnerModule, MatSortModule, MatTabsModule, MatTableModule, SharedDirectivesModule, MatIconModule, MatButtonModule],
  exports: [HistoricalBottomSheetComponent, IconAndMessageComponent, MovementHistoryTableComponent],
})
export class HistoricalBottomSheetModule {}
